import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.8727 5.9803L18.0157 9.11708M16.206 4.64965C16.6228 4.23369 17.1881 4 17.7775 4C18.367 4 18.9323 4.23369 19.3491 4.64965C19.7658 5.06561 20 5.62978 20 6.21804C20 6.8063 19.7658 7.37047 19.3491 7.78643L7.11105 20H4V16.8313L16.206 4.64965Z",
		stroke: "currentColor",
		strokeWidth: 1.7,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEdit;
